module.exports = __webpack_public_path__ + "img/upload_icon.ddb2661d.svg";